/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, you can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * Copyright Oxide Computer Company
 */
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const Refresh16Icon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g id="16/refresh">
      <path
        id="Subtract"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.80608 4.18234C7.60748 3.93171 8.46744 3.93964 9.26408 4.20499C10.0607 4.47035 10.7537 4.97968 11.2447 5.66081C11.5373 6.06665 11.7494 6.52123 11.873 7H10.9054C10.5713 7 10.404 7.40393 10.6402 7.64017L12.4697 9.46967C12.7626 9.76256 13.2375 9.76256 13.5304 9.46967L15.3599 7.64017C15.5961 7.40393 15.4288 7 15.0947 7H13.9161C13.7638 6.09883 13.4067 5.23976 12.8671 4.49121C12.1305 3.46951 11.0911 2.70552 9.89613 2.30749C8.70115 1.90945 7.41123 1.89756 6.20912 2.2735C5.52116 2.48865 4.88194 2.82458 4.31942 3.26151C3.99229 3.51559 3.99479 3.99479 4.28769 4.28769L4.64124 4.64124C4.93413 4.93413 5.40602 4.92708 5.74838 4.69391C6.07189 4.47358 6.42795 4.30059 6.80608 4.18234ZM2.08391 9H0.905354C0.571264 9 0.403952 8.59607 0.640189 8.35983L2.46969 6.53033C2.76259 6.23744 3.23746 6.23744 3.53035 6.53033L5.35986 8.35983C5.5961 8.59607 5.42878 9 5.09469 9H4.12702C4.25071 9.47903 4.46293 9.93384 4.75576 10.3398C5.2471 11.0211 5.94043 11.5304 6.73744 11.7955C7.53446 12.0606 8.39471 12.0681 9.19623 11.8169C9.57351 11.6987 9.92877 11.526 10.2516 11.3061C10.594 11.0729 11.0659 11.0659 11.3588 11.3588L11.7123 11.7123C12.0052 12.0052 12.0077 12.4844 11.6806 12.7385C11.119 13.1747 10.481 13.5102 9.79434 13.7254C8.59207 14.1022 7.30169 14.091 6.10617 13.6933C4.91064 13.2956 3.87065 12.5317 3.13364 11.5098C2.5936 10.761 2.23631 9.90157 2.08391 9Z"
        fill="currentColor"
      />
    </g>
  </svg>
)
export default Refresh16Icon
